/**
 * @description
 *
 * Трансформирует поля переданного объекта в 'Number' значение
 *
 * @param {object} object - объект, в котором необходимо произвести трансформацию
 * @param { Array<string> } propList - список ключей
 */

function transformPropsToNumber(object = {}, propList = []) {
  propList.forEach(prop => {
    if (object[prop]) {
      object[prop] = Number(object[prop])
    }
  })
}

export default transformPropsToNumber
